import { Outlet } from "react-router-dom";
import Login from '../login/Login';

function Layout(){
    return (
        <>
            <Login/>
            <Outlet />
        </>
    )
}
export default Layout;